<!--
 * @Author: Gaho
 * @Date: 2024-03-01 11:07:51
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-08 13:28:33
 * @Description: 
-->
<template>
    <div class="rules">
        <ul class="rules-lists">
            <li class="lists-item">
                {{ $t(`corgiwildRule1`) }}
            </li>
        </ul>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from "vue-i18n";

export default defineComponent({
    name: 'dialogRules',
    data(){
        return {
            $t: useI18n().t
        }
    }
})
</script>
<style lang="scss" scoped>
.rules {
    margin-top: 16px;
    .rules-lists {
        .lists-item {
            color: #93acd3;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            margin-bottom: 8px;
            position: relative;
            &::before {
                background: #93acd3;
                border-radius: 50%;
                content: "";
                height: 3px;
                left: -13px;
                position: absolute;
                top: 8px;
                width: 3px;
            }
        }
    }
}
</style>